import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable } from "rxjs";
import { environment } from "environments/environment";
import { Notification } from "../models/notification.model";

@Injectable({ providedIn: "root" })
export class NotificationsService {
  _notifications$ = new BehaviorSubject<Notification[]>([]);

  _ofEnAttentePDC$ = new BehaviorSubject<number>(null);
  _ofEnAttenteValidation$ = new BehaviorSubject<number>(null);
  _ofEnAttenteValidationQualite$ = new BehaviorSubject<number>(null);

  get notifications$(): Observable<Notification[]> {
    return this._notifications$.asObservable();
  }

  get ofEnAttentePDC$(): Observable<number> {
    return this._ofEnAttentePDC$.asObservable();
  }

  get ofEnAttenteValidation$(): Observable<number> {
    return this._ofEnAttenteValidation$.asObservable();
  }

  get ofEnAttenteValidationQualite$(): Observable<number> {
    return this._ofEnAttenteValidationQualite$.asObservable();
  }

  get notificationsBase$(): Observable<Notification[]> {
    return this._notifications$.asObservable().pipe(
      map((ns) => {
        return ns.filter((n) => !n.viewed && n.type !== "CHAT");
      }),
    );
  }

  get newNotifications$(): Observable<number> {
    return this._notifications$.asObservable().pipe(
      map((ns) => {
        return ns.filter((n) => !n.viewed && n.type !== "CHAT").length;
      }),
    );
  }

  get notifsChat$(): Observable<number> {
    return this._notifications$.asObservable().pipe(
      map((ns) => {
        return ns.filter((n) => n.type === "CHAT").length;
      }),
    );
  }

  newMessages$(conversationId: string): Observable<boolean> {
    return this._notifications$.asObservable().pipe(
      map((ns) => {
        return !!ns.filter(
          (n) => n.type === "CHAT" && n.data?.conversationId === conversationId,
        ).length;
      }),
    );
  }

  constructor(private http: HttpClient) {}

  setNotifications(notifications: Notification[]) {
    notifications = notifications.sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
    );
    this._notifications$.next([...notifications]);
  }

  loadNotifications() {
    return this.http
      .get(`${environment.api()}/notification`)
      .subscribe((res: Notification[]) => {
        this.setNotifications(res);
      });
  }

  view(notification: Notification) {
    return this.http
      .post(
        `${environment.api()}/notification/view/${notification.id}/${!notification.viewed}`,
        null,
      )
      .subscribe((res) => {
        //notification.viewed = !notification.viewed;
        //this.updateNotif(notification);
      });
  }

  clearForConvId(conversationId: string) {
    let all = this._notifications$.getValue();

    for (let index = 0; index < all.length; index++) {
      const notif = all[index];
      if (notif.data?.conversationId === conversationId) {
        this.delete(notif);
      }
    }
  }

  delete(notification: Notification) {
    return this.http
      .delete(`${environment.api()}/notification/${notification.id}`)
      .subscribe((res) => {
        this.updateNotif(notification, true);
      });
  }

  do(notification: Notification) {}

  updateNotif(notification: Notification, isDelete?: boolean) {
    let all = this._notifications$.getValue();

    const foundIndex = all.findIndex((n) => n.id === notification.id);

    if (isDelete) {
      if (foundIndex > -1) {
        all.splice(foundIndex, 1);
      }
    } else {
      if (foundIndex > -1) {
        all[foundIndex] = notification;
      } else {
        all.push(notification);
      }
    }

    const newAll = all.slice();

    this.setNotifications(newAll);
  }
}
